module.exports = __webpack_public_path__ + "img/Shlomo.c977be1.png";